document.addEventListener('DOMContentLoaded', function () {
	const hscrollButtons = document.querySelectorAll('.hscroll-btn');
	if (hscrollButtons) {
		hscrollButtons.forEach((button) => {
			button.addEventListener('click', function () {
				const scrollTargetId = button.getAttribute('data-hscroll-target');
				const isLeft = button.classList.contains('hscroll-btn--left');
				if (scrollTargetId) {
					const scrollTarget = document.querySelector(scrollTargetId) as HTMLElement;
					
					if (scrollTarget) {
						const scrollContainer = scrollTarget;
						let childWidth = 0;
						
						// Find the first visible child element of target
						const childElements = scrollTarget.children;
						for (let i = 0; i < childElements.length; i++) {
							const child = childElements[i] as HTMLElement;
							if (child.offsetLeft >= scrollContainer.scrollLeft) {
								childWidth = child.offsetWidth;
								break;
							}
						}
						const scrollAmount = isLeft ? -childWidth - 16 : childWidth + 16;
						
						if (childWidth > 0 ) {
							scrollContainer.scrollTo({
								left: scrollContainer.scrollLeft + scrollAmount,
								behavior: 'smooth',
							});
						}
					}
				}
			});
		});
	}
});
